import { render, staticRenderFns } from "./detalhes-movimentos-contas.vue?vue&type=template&id=1001998e&"
import script from "./detalhes-movimentos-contas.vue?vue&type=script&lang=js&"
export * from "./detalhes-movimentos-contas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports